<script>
  import { tick } from "svelte";
  import { POPULAR_CITIES, STORAGE_KEY, LocalStorage, capitalCase } from './utils';

  const inputs = {
    cities: "",
    otherAlsoSearchFor: "",
    otherExcludedKeywords: '',
  };
  const checkboxes = {
    nearMe: false,
    verifiedOnly: true,
    excludeUnverified: true,
  };
  const alsoSearchFor = {
    beds: {
      keywords: ["bed", "beds"],
      checked: true
    },
    ICU: {
      keywords: ["icu"],
      checked: true,
    },
    oxygen: {
      keywords: ["oxygen"],
      checked: true
    },
    ventilator: {
      keywords: ["ventilator", "ventilators"],
      checked: true
    },
    fabiflu: {
      keywords: ["fabiflu"],
      checked: true
    },
    remdesivir: {
      keywords: ["remdesivir"],
      checked: false
    },
    favipiravir: {
      keywords: ["favipiravir"],
      checked: false
    },
    tocilizumab: {
      keywords: ["tocilizumab"],
      checked: false
    },
    plasma: {
      keywords: ["plasma"],
      checked: false
    },
    tiffin: {
      keywords: ["tiffin"],
      checked: false
    }
  };
  const excludeKeywords = {
    needed: {
      keywords: ['needed'],
      checked: true,
    },
    required: {
      keywords: ['required'],
      checked: true,
    }
  };

  let links = LocalStorage.getItem(STORAGE_KEY.generated_links, []);
  let popularCityLinks = [];

  $: alsoSearchFor, inputs, checkboxes, generatePopularCityLinks();

  function generatePopularCityLinks() {
    popularCityLinks = POPULAR_CITIES.map(city => {
      return {
        city,
        href: generateLinkForCity(city)
      };
    });
  }

  function getAlsoSearchForString() {
    const keywords = Object.keys(alsoSearchFor).reduce((keywordsSoFar, item) => {
      if (alsoSearchFor[item].checked) {
        return keywordsSoFar.concat(alsoSearchFor[item].keywords);
      } else {
        return keywordsSoFar;
      }
    }, []);

    if (inputs.otherAlsoSearchFor) {
      keywords.push(inputs.otherAlsoSearchFor);
    }

    if (keywords.length > 0) {
      return `(${keywords.join(" OR ")})`;
    } else {
      return "";
    }
  }

  function getExcludedKeywordsString() {
    const keywords = Object.keys(excludeKeywords).reduce((keywordsSoFar, item) => {
      if (excludeKeywords[item].checked) {
        return keywordsSoFar.concat(excludeKeywords[item].keywords);
      } else {
        return keywordsSoFar;
      }
    }, []);

    if (inputs.otherExcludedKeywords) {
      keywords.push(inputs.otherExcludedKeywords);
    }

    return keywords.map(keyword => `-"${keyword}"`).join(' ');
  }

  function generateLinkForCity(city) {
    const base = `https://twitter.com/search`;
    const params = new URLSearchParams();

    const query = [
      checkboxes.verifiedOnly && "verified",
      city.trim(),
      getAlsoSearchForString(),
      checkboxes.excludeUnverified && '-"not verified"',
      checkboxes.excludeUnverified && '-"unverified"',
      getExcludedKeywordsString(),
    ]
      .filter(Boolean)
      .join(" ");

    params.set("q", query);

    params.set("f", "live");

    if (checkboxes.nearMe) {
      params.set("lf", "on");
    }

    const link = `${base}?${params.toString()}`;

    return link;
  }

  function generate() {
    if (!inputs.cities) {
      alert("Please enter city name(s)");
      return;
    }

    const cities = inputs.cities
      .split(",")
      .map(city => city.trim())
      .filter(Boolean);

    links = cities.map(city => {
      return {
        city,
        href: generateLinkForCity(city)
      };
    });

    tick().then(() => {
      const firstItem = document.querySelector("#city-links li");

      if (firstItem) {
        firstItem.scrollIntoView();
        firstItem.focus();

        alert('Please check the Links section');
      }

      LocalStorage.setItem(STORAGE_KEY.generated_links, links);
    });
  }

  function clearSavedLinks() {
    links = [];

    LocalStorage.removeItem(STORAGE_KEY.generated_links);
  }
</script>

<style>
  * {
    box-sizing: border-box;
  }

  main {
    font-family: sans-serif;
    margin: 2rem auto;
    max-width: 700px;
    padding: 0;
  }

  label,
  button {
    cursor: pointer;
  }

  button {
    font-size: 1.2rem;
  }

  form > div {
    margin-bottom: 12px;
  }

  li {
    margin-bottom: 4px;
  }

  .feedback {
    margin-top: 60px;
  }



  .split {
    display: flex;
    align-items: top;
    flex-wrap: wrap;
  }

  #tips {
    width: 100%;
  }

  #city-links {
    border: 1px dashed blue;
  }

  

  @media screen and (min-width: 769px) {
    #main-content {
      margin-right: 20px;
      max-width: calc(100% - 20ch - 20px - 1em);
    }

    #quick-links {
      max-width: 30ch;
      flex-grow: 0;
    }

    
  }

  @media screen and (max-width: 768px) {
    .split > * {
      width: 100%;
    }

    #quick-links {
      order: 1;
    }

    #tips {
      order: 2;
    }

    #main-content {
      order: 3;
    }

    #other-resources {
      order: 4;
    }

    #donate {
      order: 5;
    }

    .list-split-on-mobile {
      display: flex;
      flex-wrap: wrap;
      padding-left: 1em;
    }

    .list-split-on-mobile > * {
      width: 50%;
    }
  }

  @media screen and (max-width: 320px) {
    .list-split-on-mobile > * {
      width: 100%;
    }
  }
</style>

<main>
	<h1>Covid Resources</h1>

  <div class="split ">
    <div class="wrapper topWrapper">
      <div class="wrapperItem">
        <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
        <a href="https://www.reddit.com/r/india/comments/hhkrth/coronavirus_covid19_megathread_news_and_updates_6/">Covid 19 megathread</a>
      </div>
      <div class="wrapperItem">
        <img src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Ficons.iconarchive.com%2Ficons%2Fpapirus-team%2Fpapirus-apps%2F512%2Fgoogle-docs-icon.png&f=1&nofb=1" alt="doc" />
        <a href="https://docs.google.com/document/d/1rXqWdnyyDOCFubkwO-xHw-1scHkYwefiJo-4UJsmI5E/edit#heading=h.z2jxwkjio1p4">All resource Doc</a>
      </div>
      <div class="wrapperItem">
        <img src="https://www.fintechfutures.com/files/2015/07/stats-icon_chart_statistics.png" alt="tracker"/>
        <a href="https://www.covid19india.org">Tracker</a>
      </div>
    </div>
    <div class="mainWrapper" id="main-content">

      <h2>City Search</h2>
      <form on:submit|preventDefault={generate}>
        <div>
          <label for="cities">Search cities (comma-separated, e.g. indore, jamnagar)</label>
          <br />
          <input type="text" bind:value={inputs.cities} id="cities" />
        </div>

        <div>
          <p>Also search for:<p>

          {#each Object.keys(alsoSearchFor) as item (item)}
            <div>
              <input  type="checkbox" bind:checked={alsoSearchFor[item].checked} id={`alsoSearchFor-${item}`} />
              <label class="searchOpts" for={`alsoSearchFor-${item}`}>{capitalCase(item)}</label>
            </div>
          {/each}

          <div>
            <label for="alsoSearchFor-other">Other:</label>
            <input type="text" bind:value={inputs.otherAlsoSearchFor} id="alsoSearchFor-other" />
          </div>

        </div>

        <div>
          Tweets should <strong>NOT</strong> have these words:

          {#each Object.keys(excludeKeywords) as item (item)}
            <div>
              <input type="checkbox" bind:checked={excludeKeywords[item].checked} id={`excludeKeywords-${item}`} />
              <label for={`excludeKeywords-${item}`}>"{item}"</label>
            </div>
          {/each}

          <div>
            <label for="excludeKeywords-other">Other:</label>
            <input type="text" bind:value={inputs.otherExcludedKeywords} id="excludeKeywords-other" />
          </div>
        </div>

        <div>
          <input type="checkbox" bind:checked={checkboxes.nearMe} id="nearMe" />
          <label for="nearMe">Show Tweets near me</label>
        </div>

        <div>
          <input type="checkbox" bind:checked={checkboxes.verifiedOnly} id="verifiedOnly" />
          <label for="verifiedOnly">
            Show verified tweets only
            <br />
            <strong>Uncheck this for smaller cities</strong>
            <br />
            (Tweet should contain "verified")
          </label>
        </div>

        <div>
          <input type="checkbox" bind:checked={checkboxes.excludeUnverified} id="excludeUnverified" />
          <label for="excludeUnverified">
            Exclude unverified tweets
            <br />
            (Tweet should not contain "not verified" and "unverified")
          </label>
        </div>

        <div>
          <button>Generate Links</button>
        </div>
      </form>

      {#if links.length > 0}
        <h2>Generated Links</h2>

        <ol id="city-links">
          {#each links as link (link.href)}
            <li><a class="quickLink" href={link.href} target="_blank" rel="noopener noreferrer">{capitalCase(link.city)}</a></li>
          {/each}
        </ol>

        <button on:click={clearSavedLinks}>Clear saved links</button>
      {/if}
    </div>
    <div class="sideWrapper" id="quick-links">
      <h2>Quick Links</h2>

      <ol class="list-split-on-mobile ">
        {#each popularCityLinks as link (link.href)}
          <p><a class="quickLink" href={link.href} target="_blank" rel="noopener noreferrer">{capitalCase(link.city)}</a></p>
        {/each}
      </ol>

    </div>

    <div class="wrapper" id="other-resources">
      <h2>Helpline numbers</h2>
      <p>Ambulance</p>
      <div class="wrapperItem">
        <img src="https://image.flaticon.com/icons/png/512/196/196134.png" alt="ambulance" />
        <p ><strong>CENTRALIZED EMERGENCY NUMBER </strong>: 112</p>
      </div>
      <div class="wrapperItem">
        <img src="https://image.flaticon.com/icons/png/512/196/196134.png" alt="ambulance" />
        <p ><strong>AMBULANCE HELPLINE </strong>: 102</p>
      </div>
      <div class="wrapperItem">
        <img src="https://image.flaticon.com/icons/png/512/196/196134.png" alt="ambulance" />
        <p ><strong>GVK EMRI AMBULANCE </strong>: 108</p>
      </div>
      <div class="wrapperItem">
        <img src="http://getdrawings.com/vectors/helping-hand-vector-23.png" alt="ambulance" />
        <p ><strong>COVID Helpline</strong>: +91-11-23978046</p>
      </div>
    </div>

    <div class="wrapper" id="other-resources">
      <h2>Other Resources</h2>
      <p>State Specific Covid-19 Threads via Reddit community</p>
      <div class="topWrapper">
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/india/comments/fw07cd/covid19_gujarat_updates">Gujrat</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/Kerala/comments/g7bz25/coronavirus_covid19_megathread_2_news_and_updates/">Kerela</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/india/comments/fpt2jw/mp_covid19_megathread/">Madhya Pradesh</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/india/comments/fq2vqj/covid19_updates_for_maharashtra/">Maharashtra</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/india/comments/frstw5/covid19all_updates_for_odisha">Odhisa</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/user/-ImSoDone-/comments/fqpnov/covid19_updates_nagaland/">Nagaland</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/india/comments/fsbwuj/punjab_covid_updates_thread/">Punjab</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/pinkcity/comments/fps590/covid19_updates_for_rajasthan/">Rajasthan</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/Chennai/comments/gukm43/covid19_daily_updates_part_iii/">Tamil Nadu</a>
        </div>
        <div class="wrapperItem">
          <img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-512.png" alt="reddit" />
          <a href="https://www.reddit.com/r/kolkata/comments/fi5hqd/covid19_updates/">West Bengal</a>
        </div>
      </div>
      
    </div>

    

  </div>

  
    
    
  
 
  <div class="feedback wrapper">
    
    
    <div class="wrapperItem">
      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/1024px-Git_icon.svg.png" alt="twitter" />
      <p>Made with ❤️ by <a href="https://twitter.com/theStonedSage" target="_blank" rel="noopener noreferrer">Amit</a> </p> 
    </div>
  </div>
</main>
